import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/css/global.css";
import React from "react";
import ReactDOM from "react-dom";
import { jwtDecode } from "jwt-decode"; // Import jwtDecode as a named export
import lambdaClientFactory from "./helpers/LambdaClientFactory.js";
import s3ClientFactory from "./helpers/S3ClientFactory.js";
import App from "./App.js";
import { PasteDataProvider } from "./context/PasteDataContext.js";
import storage from "./helpers/storage.js";
import { AuthContextProvider } from "./context/AuthContext.js";
import { TicketContextProvider } from "./context/TicketContext.js";
import { FilterProvider } from "./context/FilterContext";

const params = new URLSearchParams(window.location.hash.slice(1));
const idTokenFromURL = params.get("id_token");

const idTokenFromLocalStorage = storage.getToken();
const idToken = idTokenFromURL || idTokenFromLocalStorage;

let username = null; // Initialize username

if (idTokenFromURL) {
  storage.setToken(idToken);
  // Remove the id_token from the URL and set the URL to the actual origin
  window.history.replaceState({}, "", window.location.origin);
}

// Decode the ID token to get the user information (like username)
if (idToken) {
  try {
    const decodedToken = jwtDecode(idToken); // Use jwtDecode to parse the token
    username = decodedToken['cognito:username'] || decodedToken['username']; // Extract username from the token
    storage.setUserName(username); // Save username to localStorage or custom storage helper
  } catch (error) {
    console.error("Error decoding ID token:", error);
  }
} else {
  username = storage.getUserName(); // Retrieve the username from localStorage if already stored
}

let lambdaClients = lambdaClientFactory(idToken);
let s3Clients = s3ClientFactory(idToken);

const render = () =>
  ReactDOM.render(
    <FilterProvider>
    <React.StrictMode>
      <AuthContextProvider>
        <TicketContextProvider>
          <PasteDataProvider>

            <App
              isSignedIn={!!idToken}
              token={idToken}
              username={username} // Pass username to App component
              {...lambdaClients}
              {...s3Clients}
            />
          </PasteDataProvider>
        </TicketContextProvider>
      </AuthContextProvider>
    </React.StrictMode>
    </FilterProvider>,
    document.getElementById("root")
  );

render();
